import React, { useState, useContext, useEffect } from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';
import policiesQuotesActions from '../../../actions/policiesQuotes.actions';
import PoliciesQuotesDispatch from '../../../contexts/policiesQuotes.dispatch';

import style from './PoliciesQuotesFilter.module.css';

const PoliciesQuotesFilter = React.memo(({
  filterState = {
    policies: false,
    quotes: false,
  }
}) => {
  const dispatch = useContext(PoliciesQuotesDispatch);
  const [opened, setOpened] = useState(false);
  const [selectedAll, setSelectedAll] = useState(true);
  const [filter, setFilter] = useState(filterState);

  useEffect(() => {
    setFilter(filterState);

    if (filterState.policies && filterState.quotes) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  }, [filterState]);

  const handleFilterToggle = () => {
    setOpened(!opened);
  };

  const handleSelectAll = event => {
    event.preventDefault();

    const filterType = Object.assign({}, filter, {
      policies: !selectedAll,
      quotes: !selectedAll,
    });

    setSelectedAll(!selectedAll);

    dispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_FILTER_CHANGE_SUCCESS,
      policies: filterType.policies,
      quotes: filterType.quotes,
    });
  };

  const handlePolicyFilter = () => {
    const policyFilter = {
      policies: !filter.policies,
      quotes: filter.quotes,
    };

    if (policyFilter.policies && policyFilter.quotes) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }

    dispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_FILTER_CHANGE_SUCCESS,
      policies: policyFilter.policies,
      quotes: policyFilter.quotes,
    });
  };

  const handleQuotesFilter = () => {
    const quotesFilter = {
      policies: filter.policies,
      quotes: !filter.quotes,
    };

    if (quotesFilter.policies && quotesFilter.quotes) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }

    dispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_FILTER_CHANGE_SUCCESS,
      policies: quotesFilter.policies,
      quotes: quotesFilter.quotes,
    });
  };

  return (
    <>
      <a
        className={style.filterLink}
        id="policies-quotes-filter"
        href="#filter"
        onClick={event => event.preventDefault()}
      >
        <span>Filter</span>
        <span className={`${style.arrow} ${opened && style.up}`} />
      </a>
      <Popover
        trigger="legacy"
        placement="bottom"
        isOpen={opened}
        target="policies-quotes-filter"
        toggle={handleFilterToggle}
        offset={-60}
        fade={false}
        className={style.filter}
      >
        <PopoverBody className={style.filterBody}>
          <div className={style.header}>
            Filter by:
            <a onClick={handleSelectAll} href="#toggle">
              {selectedAll ? 'Deselect all' : 'Select all'}
            </a>
          </div>
          <ul>
            <li>
              Policies
              <Checkbox
                checked={filter.policies}
                onChange={handlePolicyFilter}
              />
            </li>
            <li>
              Quotes
              <Checkbox checked={filter.quotes} onChange={handleQuotesFilter} />
            </li>
          </ul>
        </PopoverBody>
      </Popover>
    </>
  );
});

PoliciesQuotesFilter.propTypes = {
  filterState: PropTypes.shape({
    policies: PropTypes.bool.isRequired,
    quotes: PropTypes.bool.isRequired,
  }),
};

export default PoliciesQuotesFilter;
